import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export const ResetPasswordPage: React.FC = () => {
  const { client } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState<"idle" | "ok" | "error">("idle");

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("token") ?? "";
  }, [location.search]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!token || password !== confirm) {
      setStatus("error");
      return;
    }
    const response = await client.post("/auth/reset-password", {
      token,
      password,
    });
    if (response.ok) {
      setStatus("ok");
      setTimeout(() => navigate("/login"), 1200);
    } else {
      setStatus("error");
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: 520 }}>
      <h1 className="mb-3">Definir nova senha</h1>
      <form onSubmit={handleSubmit} className="d-grid gap-3">
        <div>
          <label className="form-label">Nova senha</label>
          <input
            className="form-control"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </div>
        <div>
          <label className="form-label">Confirmar senha</label>
          <input
            className="form-control"
            type="password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            required
          />
        </div>
        {status === "error" && (
          <div className="alert alert-danger">
            Nao foi possivel redefinir. Verifique o link e a senha.
          </div>
        )}
        {status === "ok" && (
          <div className="alert alert-success">
            Senha atualizada. Redirecionando...
          </div>
        )}
        <button className="btn btn-primary" type="submit">
          Salvar senha
        </button>
      </form>
    </div>
  );
};
